<template>
  <div id="chart-card" style="background-color: #EEF0F3;">
    <div class="chart-top">
      <div class="chart-item top-left">
        <div class="chart-data" style="position:relative">
          <!-- 骨架屏与图表有冲突，故不使用内嵌方式。 因为内边距的原因，采取v-if的方式 -->
          <a-skeleton active :loading="true" v-if="skeletonIsShow" style="padding:20px" :paragraph="{ rows: 6 }" />
          <div v-show="!skeletonIsShow">
            <div class="analy-title" style="padding:20px;box-sizing:border-box;padding-bottom:10px">
              <span>今日交易金额</span>
              <a-tooltip>
                <template slot="title">
                  {{ mainTips.todayAmountTip }}
                </template>
                <a-icon type="question-circle" />
              </a-tooltip>
            </div>
            <div v-show="ispayAmount">
              <div class="pay-amount-text">
                <span class="pay-amount">￥{{ mainChart.todayAmt }}
                </span>
                <span>共{{ mainChart.todayCnt?mainChart.todayCnt:0 }}笔</span>
              </div>
              <div id="payAmount" style="height:60px"></div>
            </div>
            <div class="payAmountSpan" v-show="ispayAmount">
              <span>昨日交易金额：￥{{ this.mainChart.yesterdayAmt }}</span>
              <span>近七天交易金额：￥{{ this.mainChart.last7DayAmt }}</span>
            </div>
            <empty v-show="!ispayAmount"/>
          </div>
        </div>
      </div>

      <div class="top-middle ft-white">
        <div class="middle-top">
          <div class="chart-item middle-larger">
            <div class="chart-data" style="background-color: #007300;">
              <a-skeleton active :loading="skeletonIsShow" :paragraph="{ rows: 1 }">
                <div class="analy-title">
                  <span>交易总金额</span>
                  <a-tooltip >
                    <template slot="title">
                      {{ mainTips.totalAmountTip }}
                    </template>
                    <a-icon type="question-circle" />
                  </a-tooltip>
                </div>
                <a-card :bordered="false" style="background-color: #007300;">
                  <a-statistic :value-style="{ color: 'white' }" style="margin-top: 10px;" :precision="2" :value="'￥' + this.mainChart.totalAmount?this.mainChart.totalAmount:'0'" />
                </a-card>
              </a-skeleton>
            </div>
          </div>
          <div class="chart-item middle-smaller">
            <div class="chart-data" style="background-color: #007373;">
              <a-skeleton active :loading="skeletonIsShow" :paragraph="{ rows: 1 }">
                <div class="analy-title">
                  <span>服务商数量</span>
                  <a-tooltip>
                    <template slot="title">
                      {{ mainTips.totalIsvTip }}
                    </template>
                    <a-icon type="question-circle" />
                  </a-tooltip>
                </div>
                <a-card :bordered="false" style="background-color: #007373;">
                  <a-statistic :value-style="{ color: 'white' }" style="margin-top: 10px" :value="this.mainChart.totalIsv" />
                </a-card>
              </a-skeleton>
            </div>
          </div>
        </div>

        <div class="middle-bottom">
          <div class="chart-item middle-larger">
            <div class="chart-data" style="background-color: #008787;"> <!-- #008787   377354 -->
              <a-skeleton active :loading="skeletonIsShow" :paragraph="{ rows: 1 }">
                <div class="analy-title">
                  <span>交易总笔数</span>
                  <a-tooltip>
                    <template slot="title">
                      {{ mainTips.totalPayCountTip }}
                    </template>
                    <a-icon type="question-circle" />
                  </a-tooltip>
                </div>
                <a-card :bordered="false" style="background-color: #008787;">
                  <a-statistic :value-style="{ color: 'white' }" style="margin-top: 10px" :value="this.mainChart.totalPayCount?this.mainChart.totalPayCount:'0' + ' 笔'" />
                </a-card>
              </a-skeleton>
            </div>
          </div>
          <div class="chart-item middle-smaller">
            <div class="chart-data" style="background-color: #005f5f;">
              <a-skeleton active :loading="skeletonIsShow" :paragraph="{ rows: 1 }">
                <div class="analy-title">
                  <span>商户数量</span>
                  <a-tooltip>
                    <template slot="title">
                      {{ mainTips.totalMchTip }}
                    </template>
                    <a-icon type="question-circle" />
                  </a-tooltip>
                </div>
                <a-card :bordered="false" style="background-color: #005f5f;">
                  <a-statistic :value-style="{ color: 'white' }" style="margin-top: 10px" :value="this.mainChart.totalMch" />
                </a-card>
              </a-skeleton>
            </div>
          </div>
        </div>
      </div>

      <div class="chart-item top-right">
        <!-- 费率水波球
        <div class="chart-data">
          <a-skeleton active :loading="skeletonIsShow" :paragraph="{ rows: 6 }">
            <div v-show="isTaskRate">
              <div id="taskRate" style="max-height: 200px;"></div>
            </div>
          </a-skeleton>
        </div>
        -->


        <!-- -->
        <div class="chart-data user-greet">
          <a-skeleton active avatar :loading="skeletonIsShow" :paragraph="{ rows: 6 }">
            <div class="user-greet-title yx-flex-h-center">
              <div class="user-greet-all">
                <div class="user-greet-img">
                  <img :src="greetImg" alt="">
                </div>
                <div class="user-greet-all" >
                  <span style="">{{ mainTips.helloTitle }}{{ mainTips.userName }}</span>
                  <div>
                    <span style="font-size: 12px;">{{ mainTips.agentName }} - {{ mainTips.roleName }}</span>
                  </div>
                </div>
              </div>
              <div>
                <i class="el-icon-refresh-right cls-refresh-main" @click="() =>{init()}"/>
              </div>
            </div>

            <div style="padding: 0 0 10px ; border-bottom:1px solid #ddd;">
              <a-tooltip>
                <template slot="title">
                  上次登录时间
                </template>
                <a-icon style="font-size: 14px;"  type="question-circle" />
              </a-tooltip>
              <span style="font-size: 12px;">&nbsp;&nbsp;{{ $store.state.currentHr.lastLoginTime }}</span>
            </div>
            <div class="quick-start">
              <div class="yx-flex-h-between ">
                <span class="quick-start-title " style="font-size: 13px;">我的账户</span>
                <div class="quick-start-title-r" @click="showDrawer" v-if="user.type===1 || user.type===2" >
                  <!--
                  <img src="@/assets/svg/more.svg" class="there-spot" alt="更多" slot="extra" @click="showDrawer">
                  -->
                  <i class="el-icon-wallet" style="color: green; font-weight: bolder"></i><span style="color: green; font-weight: bolder">提现</span>
                </div>
              </div>
              <div class="" style="font-size: 12px; margin-top: 12px;">
                <div class="yx-flex-h-between" style="margin-top: 5px;"><div>收益：</div><div>￥{{ this.mainChart.accRewardAmt }}</div></div>
                <div class="yx-flex-h-between" style="margin-top: 5px;"><div>结算：</div><div>￥{{ this.mainChart.accSettleAmt }}</div></div>
                <div class="yx-flex-h-between" style="margin-top: 5px;"><div>余额：</div><div>￥{{ this.mainChart.accBalanceAmt }}</div></div>
              </div>


              <!--
              <p class="quick-start-title ">快速开始</p>
              <ul class="quick-start-ul">
                <template v-for="menu in quickMenuList">
                  <li :key="menu.entId">
                    <router-link :to="menu.menuUri" tag="span">{{ menu.entName }}</router-link>
                  </li>
                </template>
              </ul>
              -->
            </div>
          </a-skeleton>
        </div>

      </div>

    </div>

    <div class="chart-bottom">
      <div class="chart-item bottom-left">
        <div class="chart-data">
          <a-skeleton active :loading="skeletonIsShow" :paragraph="{ rows: 6 }"/>
          <div v-show="!skeletonIsShow">
            <div>
              <div class="pay-count-title">
                <span class="chart-title" style="font-size: 13px;">交易统计</span>
                <div class="chart-padding" style="border: 1px solid #ddd;" >
                  <a-range-picker :locale="locale"
                    ref="jeeRange"
                    style="width:100%; height: 28px;"
                    :ranges="{ '最近一个月': [this._moment().subtract(1, 'months'),this._moment()] }"
                    :default-value="[this._moment().subtract(7, 'days'),this._moment()]"
                    :show-time="true"
                    format="YYYY-MM-DD"
                    @change="transactionChange"
                    :disabled-date="disabledDate"
                    @ok="payCountOk"
                    :allowClear="false"
                  >
                    <div class="change-date-layout" style="font-size: 12px; height: 28px;">
                      {{ jeeDate ? jeeDate : '最近七天' }}
                      <div class="pay-icon">
                        <div v-if="lastSevenDays" class="change-date-icon"><a-icon type="down" /></div>
                        <div v-else @click.stop="iconClick" class="change-date-icon" ><a-icon type="close-circle" /></div>
                      </div>
                    </div>
                  </a-range-picker>
                </div>
              </div>
              <div style="position: relative;">
                <div v-show="isPayCount">
                  <div id="payCount" >
                  </div>
                  <!--
                  <span style="right: 30px; position: absolute;top: 0;">单位（元）</span>
                  -->
                </div>
                <empty v-show="!isPayCount"/>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="chart-item bottom-right">
        <div class="chart-data">
          <a-skeleton active :loading="skeletonIsShow" :paragraph="{ rows: 6 }"/>
          <div v-show="!skeletonIsShow">
            <div class="pay-count-title">
              <span class="chart-title" style="font-size: 13px;">金额区间监控</span>
              <div class="chart-padding" style="border: 1px solid #ddd;">
                <a-range-picker :locale="locale"
                  style="width:100%; height: 28px;"
                  ref="jeeRangePie"
                  :ranges="{ '最近一个月': [this._moment().subtract(1, 'months'),this._moment()] }"
                  :default-value="[this._moment().subtract(7, 'days'),this._moment()]"
                  @change="payOnChange"
                  :show-time="true"
                  format="YYYY-MM-DD"
                  :disabled-date="disabledDate"
                  @ok="payTypeOk"
                  :allowClear="false"
                >
                  <div class="change-date-layout" style="font-size: 12px; height: 28px;">
                    {{ jeeDatePie ? jeeDatePie : '最近七天' }}
                    <div class="pay-icon">
                      <div v-if="!pieDays" class="change-date-icon"><a-icon type="down" /></div>
                      <div v-else @click.stop="iconPieClick" class="change-date-icon" ><a-icon type="close-circle" /></div>
                    </div>
                  </div>
                </a-range-picker>
              </div>
            </div>
            <div>
              <!-- 如果没数据就展示一个图标 -->
              <div id="payType" v-show="isPayType" style="height:300px"></div>
              <empty v-show="!isPayType" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 抽屉 -->
    <template>
      <div>
        <a-drawer
                width="500"
          title="我的账户"
          placement="right"
          :closable="true"
          :visible="visible"
          @close="onClose"
        >
          <a-row>
            <a-col :span="24">
              <a-descriptions>
                <a-descriptions-item>
                  <el-button type="danger" size="mini" @click="onAccUpdate" icon="el-icon-edit-outline" plain>修改结算账户</el-button>
                </a-descriptions-item>
              </a-descriptions>
            </a-col>
            <a-col :span="24">
              <a-descriptions>
                <a-descriptions-item label="账户属性">
                  {{ agentAccInfo.accAttr===1?'对公':'对私' }}
                </a-descriptions-item>
              </a-descriptions>
            </a-col>
            <a-col :span="24">
              <a-descriptions>
                <a-descriptions-item label="账号类型">
                  {{ agentAccInfo.accType===3?'公司账户':'银行卡' }}
                </a-descriptions-item>
              </a-descriptions>
            </a-col>
            <a-col :span="24">
              <a-descriptions>
                <a-descriptions-item label="收款账号">
                  {{ agentAccInfo.accNo }}
                </a-descriptions-item>
              </a-descriptions>
            </a-col>
            <a-col :span="24">
              <a-descriptions>
                <a-descriptions-item label="账户名称">
                  {{ agentAccInfo.accName }}
                </a-descriptions-item>
              </a-descriptions>
            </a-col>
            <a-col :span="24">
              <a-descriptions>
                <a-descriptions-item label="开户行名">
                  {{ agentAccInfo.bankName }}
                </a-descriptions-item>
              </a-descriptions>
            </a-col>
            <a-col :span="24">
              <a-descriptions>
                <a-descriptions-item label="联行号码">
                  {{ agentAccInfo.bankType }}
                </a-descriptions-item>
              </a-descriptions>
            </a-col>
            <a-col :span="24">
              <a-descriptions>
                <a-descriptions-item label="手机号码">
                  {{ agentAccInfo.phone }}
                </a-descriptions-item>
              </a-descriptions>
            </a-col>
            <a-col :span="24">
              <a-descriptions>
                <a-descriptions-item label="预估收益">
                  <span style="font-weight: bolder">{{ mainChart.accRewardAmt }}</span> 元
                </a-descriptions-item>
              </a-descriptions>
            </a-col>
            <a-col :span="24">
              <a-descriptions>
                <a-descriptions-item label="结算入账">
                  <span style="font-weight: bolder">{{ mainChart.accSettleAmt }}</span> 元
                </a-descriptions-item>
              </a-descriptions>
            </a-col>
            <a-col :span="24">
              <a-descriptions>
                <a-descriptions-item label="账户余额">
                  <span style="font-weight: bolder">{{ mainChart.accBalanceAmt }}</span> 元
                </a-descriptions-item>
              </a-descriptions>
            </a-col>
            <a-col :span="24">
              <a-descriptions>
                <a-descriptions-item label="提现税费">
                  <div style="color: red;">提现费2元/笔，税票费8.5%</div>
                </a-descriptions-item>
              </a-descriptions>
            </a-col>
            <a-col :span="24">
              <a-descriptions>
                <a-descriptions-item label="实拨金额" v-if="Number(agentAccDfAmt - (agentAccDfAmt*0.085 + 2)).toFixed(2) > 0">
                  <span style="color: green; font-weight: bolder">
                    {{ Number(agentAccDfAmt - (agentAccDfAmt*0.085 + 2)).toFixed(2) }}
                  </span> 元
                </a-descriptions-item>
                <a-descriptions-item label="实拨金额" v-else>
                  <span style="color: green; font-weight: bolder">
                    0
                  </span> 元
                </a-descriptions-item>
              </a-descriptions>
            </a-col>
            <a-col :span="24">
              <a-descriptions>
                <a-descriptions-item label="提现金额">
                  <el-input-number :precision="2" :max="Number(mainChart.accBalanceAmt)" size="mini" :controls="false" v-model="agentAccDfAmt" >
                  </el-input-number> 元
                  <el-button style="margin-left: 5px;" type="primary" size="mini" @click="onCashOut" icon="el-icon-wallet">提现申请</el-button>
                </a-descriptions-item>
              </a-descriptions>
            </a-col>

          </a-row>
        </a-drawer>
      </div>
    </template>

    <el-dialog
            title="修改结算账户信息"
            :visible.sync="showDlg"
            class="dlg-normal"
            width="40%">
      <div>
        <table style="margin: auto">
          <tr>
            <td><el-tag class="txt-tag">账户属性</el-tag></td>
            <td>
              <el-select v-model="agentAcc.accAttr" size="small" @change="onAccAttrChange"
                         style="width: 100%;">
                <el-option
                        v-for="item in _enums.SettleDfTypeEnum"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <td><el-tag class="txt-tag">收款账号</el-tag></td>
            <td><el-input size="small" v-model="agentAcc.accNo"></el-input></td>
          </tr>
          <tr>
            <td><el-tag class="txt-tag">账户名称</el-tag></td>
            <td><el-input size="small" v-model="agentAcc.accName"></el-input></td>
          </tr>
          <tr v-if="showCnaps">
            <td><el-tag class="txt-tag">联行号码</el-tag></td>
            <td><el-input size="small" v-model="agentAcc.bankType"></el-input></td>
          </tr>
          <tr>
            <td><el-tag class="txt-tag">手机号码</el-tag></td>
            <td><el-input size="small" v-model="agentAcc.phone"></el-input></td>
          </tr>
        </table>
      </div>
      <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="showDlg = false">取 消</el-button>
                <el-button size="small" type="primary" @click="updateAgentAcc">确 定</el-button>
            </span>
    </el-dialog>
  </div>
</template>

<script>

  import { TinyArea, Column, DualAxes, Pie, Liquid, measureTextWidth } from '@antv/g2plot'
  import { timeFix } from '../../utils/util'
  import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
  import empty from './empty' // 空数据展示的组件，首页自用
  import { getPayAmountWeek, getNumCount, getPayCount, getPayType, getTaskRate, getAgentAccInfo } from '../../api/manage'
  import {getRequest, putRequest} from "../../utils/api";
  import {AGENT_ACC_INFO} from "../../utils/cons";
  import {deepClone} from "../../utils/datatool";
  /*
  import store from '@/store'
*/
  export default {
    name: "Analysis",
    data () {
      return {
        showCnaps: false,
        showDlg: false,
        agentAcc: {},
        locale,
        skeletonIsShow: false, // 骨架屏是否显示
        skeletonReqNum: 0, // 当所有数据请求完毕后关闭骨架屏（共四个请求）
        lastSevenDays: true, // 最近七天是否显示
        pieDays: false, // 饼状图的关闭按钮是否展示
        visible: false,
        recordId: 1, // store.state.user.userId,
        searchData: {}, // 时间选择条件

        greetImg: this.$store.state.currentHr.userface,// store.state.user.avatarImgPath, // 头像图片地址
        isPayType: true, // 支付方式是否存在数据
        isPayCount: true, // 交易统计是否存在数据
        ispayAmount: true, // 今日交易金额是否存在数据
        isTaskRate: true, // 任务是否存在数据
        jeeDate: undefined, // 自定义日期选择框所用状态
        jeeDatePie: undefined, // 自定义日期选择框所用状态-支付方式
        isAdmin: 1, // store.state.user.isAdmin, // 是否为超级管理员
        mainTips: { // 主页提示
          todayAmountTip: '今日成功交易金额及笔数', // 今日交易提示文字
          totalAmountTip: '成功交易总金额', // 交易总金额提示文字
          totalPayCountTip: '成功交易总笔数', // 交易总笔数提示文字
          totalIsvTip: '服务商数量', // 服务商数量提示文字
          totalMchTip: '直拓+间推商户，包含已关停商户', // 商户数量提示文字
          helloTitle: '',
          userName: '',
          roleName: '',
          agentName: ''
        },
        agentAccDfAmt: 0,
        agentAccInfo: {},
        mainChart: { // 主页统计数据
          taskRateData: 0,
          payAmountData: [], // 近七天交易图表
          payCount: [], // 交易统计图表
          payType: [], // 支付方式统计图表
          todayAmt: 0.00, // 今日交易金额
          todayCnt: 0, // 今日交易笔数
          yesterdayAmt: 0.00, // 昨日交易金额
          last7DayAmt: 0.00, // 近7天总交易金额
          totalPayCount: 0, // 交易总笔数
          totalAmount: 0.00, // 交易总金额
          totalIsv: 0, // 当前服务商总数
          totalMch: 0, // 当前商户总数
          accRewardAmt: 0, // 账户总收益
          accSettleAmt: 0, // 账户已结算
          accBalanceAmt: 0, // 账户余额
        },
        isFirstLoad: true,
        tinyArea: {},
        liquid: null,
        columnPlot: null, // 柱状图数据
        piePlot: null, // 环图数据
        skeletonMaxNum: 5 // 骨架数量
      }
    },
    components: { empty },
    methods: {
      queryAccInfo () {
      },
      init () {
        const that = this

        if (('ENT_C_MAIN_TASK_RATE')) {
          // 任务
          getTaskRate().then(res => {
            that.mainChart.taskRateData = res.taskRate

            that.initTaskRate()

            that.skeletonClose(that)
          }).catch((err) => {
            console.error(err)
            that.skeletonClose(that)
            this.isTaskRate = false
          })
        } else {
          this.isTaskRate = false
          that.skeletonClose(that)
        }

        if (('ENT_C_MAIN_PAY_AMOUNT_WEEK')) {
          // 周总交易金额
          getPayAmountWeek().then(res => {
            that.mainChart.payAmountData = res.dataArray
            res.dataArray &&  res.dataArray.length === 0 ? this.ispayAmount = false : this.ispayAmount = true
            that.mainChart.todayCnt = res.todayCnt
            that.mainChart.todayAmt = res.todayAmt
            that.mainChart.last7DayAmt = res.last7DayAmt
            that.mainChart.yesterdayAmt = (res.yesterdayAmt)
            that.initPayAmount()
            that.skeletonClose(that)
          }).catch((err) => {
            console.error(err)
            that.skeletonClose(that)
            this.ispayAmount = false
          })
        } else {
          this.ispayAmount = false
          that.skeletonClose(that)
        }
        if (('ENT_C_MAIN_NUMBER_COUNT')) {
          // 数据统计
          getNumCount().then(res => {
            that.mainChart.totalMch = res.totalMch
            that.mainChart.totalIsv = res.totalIsv
            that.mainChart.totalAmount = res.totalAmount
            that.mainChart.totalPayCount = res.totalCount
            that.mainChart.accRewardAmt = res.accRewardAmt
            that.mainChart.accSettleAmt = res.accSettleAmt
            that.mainChart.accBalanceAmt = res.accBalanceAmt
            that.skeletonClose(that)
          }).catch((err) => {
            console.error(err)
            that.skeletonClose(that)
          })
        } else {
          that.skeletonClose(that)
        }
        // 交易统计
        if (('ENT_C_MAIN_PAY_COUNT')) {
          getPayCount(that.searchData).then(res => {
            that.mainChart.payCount = res
            // console.log('交易统计', res)
            res.length === 0 ? this.isPayCount = false : this.isPayCount = true
            that.initPayCount()
            that.skeletonClose(that)
          }).catch((err) => {
            console.error(err)
            this.isPayCount = false
            that.skeletonClose(that)
          })
        } else {
          this.isPayCount = false
          that.skeletonClose(that)
        }
        if (('ENT_C_MAIN_PAY_TYPE_COUNT')) {
          // 支付类型统计
          getPayType(that.searchData).then(res => {
            that.mainChart.payType = res[0]
            res[0].length === 0 ? this.isPayType = false : this.isPayType = true
            that.initPayType()
            that.skeletonClose(that)
          }).catch((err) => {
            console.error(err)
            this.isPayType = false
            that.skeletonClose(that)
          })
        } else {
          this.isPayType = false
          that.skeletonClose(that)
        }
      },
      initTaskRate () {
        /* 费率水波球
        this.liquid.render()
        this.liquid.changeData(this.mainChart.taskRateData)
        */
      },
      initPayAmount () {
        if(this.isFirstLoad) this.tinyArea.render()
        this.tinyArea.changeData(this.mainChart.payAmountData)
      },
      initPayCount () {
        if(this.isFirstLoad) this.columnPlot.render()
        this.columnPlot.changeData([this.mainChart.payCount, this.mainChart.payCount])
      },
      initPayType () {
        if(this.isFirstLoad) this.piePlot.render()
        this.piePlot.changeData(this.mainChart.payType)
      },
      renderStatistic: function (containerWidth, text, style) {
        const { width: textWidth, height: textHeight } = measureTextWidth(text, style)
        const R = containerWidth / 2
        // r^2 = (w / 2)^2 + (h - offsetY)^2
        let scale = 0.5 // 饼图内文字缩放
        if (containerWidth < textWidth) {
          scale = Math.min(Math.sqrt(Math.abs(Math.pow(R, 2) / (Math.pow(textWidth / 2, 2) + Math.pow(textHeight, 2)))), 1)
        }
        const textStyleStr = `width:${containerWidth}px`
        return `<div style="${textStyleStr};font-size:${scale}em;line-height:${scale < 1 ? 1 : 'inherit'};">${text}</div>`
      },
      showDrawer () {
        console.log("showDrawer")
        getAgentAccInfo(this.user.agentIdS).then(res => {
          this.agentAccInfo = res
        }).catch((err) => {
          console.error(err)
        })
        this.agentAccDfAmt = 0
        this.visible = true
      },
      onCashOut () {
        if (this.agentAccDfAmt <= 0.00) {
          this.$message.warning("请输入提现金额");
          return
        }
        this.visible = false
        console.log("onCashOut")
        putRequest("/rpt/comp/agent/rewards/cashOut" + "?id=" + this.user.agentIdS  + "&amount=" + this.agentAccDfAmt).then(resp => {
          this.init()
          if (resp && resp.obj) {
            console.log("AGENT_ACC_INFO", resp)
          } else {
            resolve({})
          }
        });
      },
      onAccAttrChange () {
        this.showCnaps = this.agentAcc.accAttr === 1
      },
      onAccUpdate () {
        this.agentAcc = deepClone(this.agentAccInfo)
        this.showCnaps = this.agentAcc.accAttr === 1
        this.showDlg = true
      },
      updateAgentAcc() {
        console.log("agentAcc", this.agentAcc)
        if (!this.agentAcc.accNo) {
          this.$message.warning("账号不可空");
          return
        }
        if (!this.agentAcc.accName) {
          this.$message.warning("账户名不可空");
          return
        }
        if (!this.agentAcc.phone) {
          this.$message.warning("手机号不可空");
          return
        }
        if (this.agentAcc.accAttr === 1 && !this.agentAcc.bankType) {
          this.$message.warning("联行号必填");
          return
        }
        this.showDlg = false;
        this.visible = false
        let reqData = {
          id: this.user.agentIdS,
          stlAccName: this.agentAcc.accName,
          stlAccNo: this.agentAcc.accNo,
          stlAccPhone: this.agentAcc.phone,
          stlAccTypeId : this.agentAcc.accAttr === 1 ? 1 : 2,
          stlBankCnapsCode: this.agentAcc.bankType
        }
        this.putRequest("/agent/updateAgentAcc", reqData).then(resp => {
          if (resp) {
          }
        })
      },
      onClose () {
        this.visible = false
      },
      payOnChange (date, dateString) {
        this.searchData.createdStart = dateString[0] // 开始时间
        this.searchData.createdEnd = dateString[1] // 结束时间
        this.pieDays = true
        this.jeeDatePie = dateString[0] + ' ~ ' + dateString[1]
      },
      // 交易统计，日期选择器，关闭按钮点击事件
      iconClick (dates) {
        this.searchData.createdStart = this._moment().subtract(7, 'days').format('YYYY-MM-DD') // 开始时间
        this.searchData.createdEnd = this._moment().format('YYYY-MM-DD') // 结束时间
        this.payCountOk()
        this.jeeDate = '最近七天'
        this.lastSevenDays = true
      },
      // 支付方式，日期选择器，关闭按钮点击事件
      iconPieClick () {
        this.searchData.createdStart = this._moment().subtract(7, 'days').format('YYYY-MM-DD') // 开始时间
        this.searchData.createdEnd = this._moment().format('YYYY-MM-DD') // 结束时间
        this.payTypeOk()
        this.jeeDatePie = '最近七天'
        this.pieDays = false
      },
      disabledDate (current) {
        // 当天之前的三十天，可选。 当天也可选
        return current < this._moment().subtract(32, 'days') || current > this._moment().endOf('day')
      },
      transactionChange (dates, dateStrings) {
        this.searchData.createdStart = dateStrings[0] // 开始时间
        this.searchData.createdEnd = dateStrings[1] // 结束时间
        this.jeeDate = dateStrings[0] + ' ~ ' + dateStrings[1]
        this.lastSevenDays = false
      },
      payCountOk () {
        const that = this
        getPayCount(that.searchData).then(res => {
          res.length === 0 ? this.isPayCount = false : this.isPayCount = true
          that.columnPlot.changeData([res, res])
        })
      },
      payTypeOk () {
        const that = this
        getPayType(that.searchData).then(res => {
          res[0].length === 0 ? that.isPayType = false : that.isPayType = true
          that.piePlot.changeData(res[0])
        })
      },
      skeletonClose (that) {
        // 每次请求成功，skeletonReqNum + 1,当大于等于4时， 取消骨架屏展示
        that.skeletonReqNum++
        that.skeletonReqNum >= this.skeletonMaxNum ? that.skeletonIsShow = false : that.skeletonIsShow = true
        if (that.skeletonReqNum >= this.skeletonMaxNum) {
          this.isFirstLoad = false
        }
      }
    },
    computed: {

      user() {
        return this.$store.state.currentHr;
      },
      // 快速菜单集合
      quickMenuList: function () {
        const result = []

        result.push(
                { entId: 1, menuUri: '/', entName: '我的商户' },
                { entId: 1, menuUri: '/', entName: '服务商信息' },
                { entId: 1, menuUri: '/', entName: '我的商户' },
                { entId: 1, menuUri: '/', entName: '服务商信息' },
                { entId: 1, menuUri: '/', entName: '我的商户' },
                { entId: 1, menuUri: '/', entName: '服务商信息' },
                { entId: 1, menuUri: '/', entName: '我的设备' },
                { entId: 1, menuUri: '/', entName: '设备调拨' }
        )

        /**
        const putResult = function (item) {
          for (let i = 0; i < item.length; i++) {
            if (item[i].menuUri && item[i].quickJump === 1) {
              result.push(item[i])
            }
            if (item[i].children) {
              putResult(item[i].children)
            }
          }
        }

        // putResult(this.$store.state.user.allMenuRouteTree)
        */
        return result
      }
    },
    mounted () {
      /*  费率水波球
      this.liquid = new Liquid('taskRate', {
        percent: this.mainChart.taskRateData
      });
       */

      this.tinyArea = new TinyArea('payAmount', {
        autoFit: true,
        data: this.mainChart.payAmountData,
        smooth: true,
        areaStyle: {
          fill: 'l(270) 0:#ffffff 0.5:#7ec2f3 1:#1890ff',
        }
      })

      this.columnPlot = new DualAxes('payCount', {
        data: [this.mainChart.payCount, this.mainChart.payCount],
        yField: ['amt', 'cnt'],
        yAxis: {
          // 格式化左坐标轴
          amt: {
            min: 0,
            label: {
              formatter: (val) => {
                return '¥' + Number(val).toLocaleString()
              },
              style: {
                fontSize: 9,
                fill: 'rgb(0,0,0)',
                // opacity: 0.6,
              },
            },
          },
          // 隐藏右坐标轴 false
          cnt: false,
          /*{
            min: 0,
            max:100,
            label: false
          },*/
        },
        xAxis: {
          label: {
            // autoHide: true,
            rotate: 6,//倾斜度
            offset: 10, //底部文字距离图标的位置
            formatter: (val) => {
              return val
            },
            style: {
              fontSize: 9,
              fill: 'rgb(0,0,0)',
              // opacity: 0.6,
            },
          },
        },
        geometryOptions: [
          {
            geometry: 'column',
            color: '#5B8FF9',
            columnWidthRatio: 0.4,
            label: {
              // 可手动配置 label 数据标签位置
              position: 'top', // 'top', 'bottom', 'middle',
              formatter: (item) => {
                return '' + item.amt.toLocaleString();
              },
              // 配置样式
              style: {
                fontSize: 8,
                fill: 'rgb(0,0,0)',
                // opacity: 0.6,
              },
            },
          },
          {
            geometry: 'line',
            smooth: true,
            color: '#5AD8A6',
            tooltip: false,
            point: {
              color: '#4faf83',
              style: { }
            }
          },
        ],
        // 更改柱线交互，默认为 [{type: 'active-region'}]
        interactions: [
          {
            type: 'element-highlight',
          },
          {
            type: 'active-region',
          },
        ],
        annotations: {
        },
        appendPadding: [12,0,0,5],
   /// this.columnPlot = new Column('payCount', {
        xField: 'title',
        /// data: this.mainChart.payCount,
        /// yField: 'amt',
        marginRatio: 0,
        height: 300,
        /// appendPadding: [30,0,0,15],
        color: '#009100', // 设置单一颜色
        meta: {
          title: {
            alias: '日期',
          },
          amt: {
            alias: '金额(元)',
          },
          cnt: {
            alias: '笔数',
          },
        },
      tooltip: {
          fields: ['title', 'cnt', 'amt'],
          // 处理弹窗数值展示
          formatter: (datum) => {
            // 如果是写死的常量则可以不进行声明
            return { title: datum.title, cnt: datum.cnt, amt: '￥' + datum.amt.toLocaleString(), rate: 20 }
          },
          // 自定义 item 模板：每项记录的默认模板，自定义模板时必须包含各个 dom 节点的 class。
          itemTpl: `
              <li class="g2-tooltip-list-item">
                <span class="g2-tooltip-marker" style="background-color: #5AD8A6;"></span>
                <span class="g2-tooltip-value" style="font-size: 13px;">{cnt}<span style="margin-left: 1px; font-size: 12px; color: #696969">笔</span></span>
                <br><br>
                <span class="g2-tooltip-marker" style="background-color: #5B8FF9;"></span>
                <span class="g2-tooltip-value" style="font-size: 13px;">{amt}<span style="margin-left: 1px; font-size: 12px; color: #696969;">元</span></span>
              </li>
            `
        },
        /*///
                label: {
                  // 可手动配置 label 数据标签位置
                  position: 'top', // 'top', 'bottom', 'middle',
                  formatter: (item) => {
                    return item.amt.toLocaleString();
                  },
                  // 配置样式
                  style: {
                    fontSize: 8,
                    fill: 'rgb(0,0,0)',
                    // opacity: 0.6,
                  },
                }
        ///*/
      })

      this.piePlot = new Pie('payType', {
        width: '100%',
        appendPadding: [10, 16, 10, 10], // 增加额外的边距，防止左侧的辅助文字被遮挡
        data: this.mainChart.payType,
        angleField: 'typeAmount', // 金额  // 笔数 typeCount
        colorField: 'typeName',
        radius: 1,
        innerRadius: 0.64,
        autoFit: true,
        color: [ // 饼图颜色范围 20%递增渐变
/* */
          '#a7eb99',
          '#98d78a',
          '#8ac37c',
          '#7bae6e',
          '#70a064',
          '#6a965c',
          '#668e58',
          '#5d8354',
          '#53784c',
          '#4f6e47',


          /**
          '#4d95d7',
          '#4886c3',
          '#4377af',
          '#3b71a0',
          '#356891',
          '#315d82',
          '#334e73',
          '#2e4869',
          '#2e3c5f',
          '#223a55',
           */
        ],
        meta: {
          value: {
            formatter: (v) => `${v} ¥`
          }
        },
        label: {
          type: 'inner',
          offset: '-50%',
          style: {
            textAlign: 'center'
          },
          autoRotate: false,
          content: '{value}'
        },
        statistic: {
          title: {
            offsetY: -4,
            customHtml: (container, view, datum) => {
              const { width, height } = container.getBoundingClientRect()
              const d = Math.sqrt(Math.pow(width / 2, 2) + Math.pow(height / 2, 2))
              const text = datum ? (datum.typeName + '<br><span style="color: #008787;font-size: 12px; font-weight: bolder;">' + datum.typeCount + '笔</span>') : '总计'
              return this.renderStatistic(d, text, { fontSize: 28 })
            }
          },
          content: {
            offsetY: 4,
            style: {
              fontSize: '32px'
            },
            customHtml: (container, view, datum, data) => {
              const { width } = container.getBoundingClientRect()
              // 在这里保留小数点后两位 toLocaleString
              // const fixedTwo = data.reduce((r, d) => r + d.typeAmount, 0).toFixed(2)
              // const text = datum ? `¥ ${Number(datum.typeAmount).toFixed(2)}` : `¥ ${fixedTwo}`
              const text = datum ? `¥ ${datum.typeAmount}` : `¥ ${Number(data.reduce((r, d) => r + d.typeAmount, 0)).toFixed(2)}`
              return this.renderStatistic(width, text, { fontSize: 32 })
            }
          }
        },
        // 添加 中心统计文本 交互
        interactions: [{ type: 'element-selected' }, { type: 'element-active' }, { type: 'pie-statistic-active' }]
      })

      // 用户名信息以及时间问候语句。由于退出登陆才让他更改成功，所以这里的数据先从 vuex中获取
      this.mainTips.helloTitle = `${timeFix()}，` // this.$store.state.user.userName
      this.mainTips.userName = this.$store.state.currentHr.name
      this.mainTips.agentName = this.$store.state.currentHr.agentName
      this.mainTips.roleName = this.$store.state.currentHr.roles[0]?this.$store.state.currentHr.roles[0].nameZh:null
      this.init()
      // 去掉交易统计 日期选择框，原生的边框
      this.$refs.jeeRange.$refs.picker.$el.firstChild.style.border = 'none'
      this.$refs.jeeRangePie.$refs.picker.$el.firstChild.style.border = 'none'

    }
  }
</script>

<style lang="less" scoped>
  @import './index.less'; // 响应式布局
  .user-greet {
    font-size: 19px;
    font-weight: 500;

    .quick-start {
      box-sizing: border-box;
      padding-top: 20px;

      .quick-start-title {
        font-size: 16px;
        font-weight: 500;
        text-align: left;
        margin-bottom:0;
      }
      .quick-start-title-r {
        cursor:pointer;
        color: green;
        font-size: 13px;
        font-weight: 500;
        text-align: right;
        margin-bottom:0;
      }
      .quick-start-ul {
        font-size: 13px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        width: 100%;
        padding: 0;
        margin-bottom:0;

        li {
          margin-right: 20px;
          margin-top: 10px;
          text-align: left;

          :hover {
            color: #1A79FF;
          }
        }
        li:hover {
          cursor:pointer;
        }
      }
    }
  }
  .chart-padding {
    box-sizing: border-box;
    padding: 0 5px;
    width:300px;
  }

  .user-greet-title{
    box-sizing:border-box;
    // padding-bottom: 1px;
    display:flex;
    justify-content:space-between;
    // border-bottom:1px solid #ddd;

    .user-greet-all {
      display:flex;
      flex-direction:row;
      font-size: 14px;

      .user-greet-img {
        width:30px;
        height:30px;
        border-radius:50%;
        overflow:hidden;
        background:#ddd;
        margin-right:10px;
        img {
          width:30px;
          height:30px;
        }
      }
      .user-greet-all {
        display:flex;
        flex-direction:column;
        justify-content: space-around;
      }
    }
  }
  .analy-title {
    display:flex;
    justify-content:space-between;
    padding-bottom:0;
    align-items: center;
  }
  .there-spot:hover {
    cursor:pointer;
  }
  .ant-calendar-picker-input {
    border:none !important
  }
  .payAmountSpan {
   display:flex;
   justify-content:space-between;
   width: 100%;
   box-sizing: border-box;
   position: absolute;
   bottom:20px;
   padding:0 20px;
   box-sizing: border-box;
  }

  .chart-data {
    padding:20px;
    box-sizing: border-box;
  }

  .top-left {

    .chart-data {
      padding:0;
    }
  }

  .pay-amount-text {
    display: flex;
    padding: 0 20px 0 16px;
    box-sizing: border-box;
    height: 33px;
    line-height: 33px;
    align-items: baseline;
    margin-bottom: 10px;
    .pay-amount {
      font-size: 33px;
      margin-right: 10px;
    }
  }

  .pay-count-title {
    display:flex;
    flex-wrap: wrap;
    justify-content:space-between;
    align-items:center;
    .pay-count-date{
      display:flex;
      justify-content:space-around;
    }
  }
  .chart-padding {
    box-sizing: border-box;
    max-width:330px;
    min-width:260px;
    flex-grow: 1;
    flex-shrink:1;
    margin-bottom: 20px;
  }
  .change-date-layout {
    padding-left: 11px;
    align-items: center;
    display:flex;
    justify-content:space-between;

    .change-date-icon {
      width:50px;
      height:36px;
      display:flex;
      align-items:center;
      justify-content:center;
    }
  }

  .chart-title {
    font-size: 16px;
    font-weight: 500;
    margin-right:20px;
    margin-bottom:20px;
  }
</style>
